(function () {
  'use strict';

  // ── FAQ Accordion ──────────────────────────────────────────
  function initFaq(root) {
    var items = (root || document).querySelectorAll('.faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var header = item.querySelector('.faq__item-header');
      var toggle = item.querySelector('.faq__item-toggle');
      var answer = item.querySelector('.faq__item-answer');
      if (!header) return;
      header.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('.faq__item-toggle');
          var a = i.querySelector('.faq__item-answer');
          if (t) { t.setAttribute('aria-expanded','false'); t.classList.remove('faq__item-toggle--active'); t.classList.add('faq__item-toggle--inactive'); t.querySelector('.faq__item-toggle-icon').innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="7" y1="0" x2="7" y2="14" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/><line x1="0" y1="7" x2="14" y2="7" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/></svg>'; }
          if (a) a.classList.add('faq__item-answer--hidden');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          if (toggle) { toggle.setAttribute('aria-expanded','true'); toggle.classList.add('faq__item-toggle--active'); toggle.classList.remove('faq__item-toggle--inactive'); toggle.querySelector('.faq__item-toggle-icon').innerHTML = '<svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0" y1="1" x2="14" y2="1" stroke="#030303" stroke-width="2" stroke-linecap="round"/></svg>'; }
          if (answer) answer.classList.remove('faq__item-answer--hidden');
        }
      });
    });
  }
  initFaq();

  // ── Features home accordion ────────────────────────────────
  document.querySelectorAll('.section-features__card').forEach(function (card) {
    card.addEventListener('click', function () {
      var isOpen = card.classList.toggle('is-open');
      card.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  // ── Timeline on-scroll ─────────────────────────────────────
  var timelineCards = document.querySelectorAll('.timeline__card');
  if (timelineCards.length && 'IntersectionObserver' in window) {
    var tlObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); tlObs.unobserve(e.target); } });
    }, { threshold: 0.15 });
    timelineCards.forEach(function (c) { tlObs.observe(c); });
  } else {
    timelineCards.forEach(function (c) { c.classList.add('is-visible'); });
  }

  // ── How-it-works on-scroll ─────────────────────────────────
  var hiwCards = document.querySelectorAll('.how-it-works__card');
  if (hiwCards.length && 'IntersectionObserver' in window) {
    var hiwObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); hiwObs.unobserve(e.target); } });
    }, { threshold: 0.12 });
    hiwCards.forEach(function (c) { hiwObs.observe(c); });
  } else {
    hiwCards.forEach(function (c) { c.classList.add('is-visible'); });
  }

  // ── Swiper init ────────────────────────────────────────────
  function initSwipers() {
    if (typeof Swiper === 'undefined') return;
    if (document.querySelector('.features-list-swiper') && !document.querySelector('.features-list-swiper').swiper) {
      new Swiper('.features-list-swiper', { slidesPerView: 'auto', loop: true, speed: 500, autoplay: { delay: 3000, disableOnInteraction: false } });
    }
    if (document.querySelector('.features-advantages-swiper') && !document.querySelector('.features-advantages-swiper').swiper) {
      new Swiper('.features-advantages-swiper', { slidesPerView: 'auto', loop: true, speed: 500, autoplay: { delay: 3000, disableOnInteraction: false } });
    }
  }
  if (typeof Swiper !== 'undefined') {
    initSwipers();
  } else if (document.querySelector('.features-list-swiper, .features-advantages-swiper')) {
    var sw = document.createElement('script');
    sw.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    sw.onload = initSwipers;
    document.head.appendChild(sw);
  }

  // ── Variant selection (product page) ──────────────────────
  document.querySelectorAll('.product-variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.product-variant-group');
      if (group) group.querySelectorAll('.product-variant-btn').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed','false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed','true');
      // Update hidden variant input
      var input = document.getElementById('product-variant-id');
      if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
    });
  });

  // ── Add to cart (product page) ────────────────────────────
  var atcForm = document.getElementById('product-add-to-cart-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = atcForm.querySelector('[type="submit"]');
      var origText = btn ? btn.querySelector('span').textContent : '';
      if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Adding...'; }
      var data = new FormData(atcForm);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.querySelector('span').textContent = 'Added!'; }
          document.dispatchEvent(new CustomEvent('cart:add'));
          setTimeout(function () { if (btn) { btn.disabled = false; btn.querySelector('span').textContent = origText; } }, 2000);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.querySelector('span').textContent = origText; }
        });
    });
  }

})();

/* =====================================================
   Scroll Reveal — global IntersectionObserver
   ===================================================== */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Elements that reveal with sibling stagger (80ms per item) */
  var STAGGER_SELS = [
    '.section-stats__card',
    '.testimonials__card',
    '.feature__slider-card',
    '.how-it-works__card',
    '.material-choice__card',
    '.product__card',
    '.features__card',
    '.features__card-item',
    '.stats__card',
  ];

  /* Single elements with directional reveal */
  var SINGLE_SELS = [
    { sel: '.section-stats__headline-wrap',  type: 'fade'  },
    { sel: '.testimonials__header',          type: 'fade'  },
    { sel: '.features__header-center',       type: 'fade'  },
    { sel: '.material-choice__header',       type: 'fade'  },
    { sel: '.how-it-works__header',          type: 'fade'  },
    { sel: '.timeline__header-container',    type: 'fade'  },
    { sel: '.product__header',               type: 'fade'  },
    { sel: '.how-it-works__image-wrap',      type: 'left'  },
    { sel: '.how-it-works__steps-wrap',      type: 'right' },
    { sel: '.material-choice__rule',         type: 'fade'  },
    { sel: '.hero__wrapper',                 type: 'fade'  },
  ];

  function mark(el, type, delayMs) {
    el.classList.add('sr-reveal');
    if (type === 'fade')  el.classList.add('sr-reveal--fade');
    if (type === 'left')  el.classList.add('sr-reveal--left');
    if (type === 'right') el.classList.add('sr-reveal--right');
    if (delayMs) el.style.transitionDelay = delayMs + 'ms';
  }

  /* Stagger: group siblings by parent, assign incremental delay */
  STAGGER_SELS.forEach(function (sel) {
    var parentMap = new Map();
    document.querySelectorAll(sel).forEach(function (el) {
      var p = el.parentElement;
      var idx = parentMap.get(p) || 0;
      parentMap.set(p, idx + 1);
      mark(el, 'up', idx * 80);
    });
  });

  /* Singles */
  SINGLE_SELS.forEach(function (cfg) {
    document.querySelectorAll(cfg.sel).forEach(function (el) {
      mark(el, cfg.type, 0);
    });
  });

  /* Observe */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.sr-reveal').forEach(function (el) {
    observer.observe(el);
  });
})();
